import { Text, TextSize } from '@vizit/atoms';
import { cx } from '@vizit/theme';
import { useDropZone } from './dropzone-provider';
interface DropZoneErrorProps {
  /**
   * Additional CSS classes to apply to the error container.
   */
  className?: string;
}

function DropZoneError(props: DropZoneErrorProps) {
  const { className, ...other } = props;

  const { fileErrors, allowsMultiple } = useDropZone();

  return (
    <>
      {(fileErrors.size > 0 || allowsMultiple) && (
        <Text size={TextSize.Sm} className={cx('text-center text-error-primary h-10', className)} {...other}>
          {/* Join the file errors with a space. Will display on a single line. */}
          {[...fileErrors].join(' ')}
        </Text>
      )}
    </>
  );
}

export { DropZoneError };
export type { DropZoneErrorProps };
